import React, { Component } from 'react';
import { Row, Col, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { SvgAssets } from '../../assets/icons/iconSvg';
import GaugeChart from 'react-gauge-chart';
import product from '../../assets/img/product.png';
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { getData } from '../../store/sagas/dashboardApi';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import color from '../../constants/Colors';
import { notificacion, validateTokenExpired, getStatePage } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import ModalAddCart from "../reusable/modals/AddCart";
import BarchartPedidos from '../reusable/charts/BarChartPedidoMes';
import CardPrecios from '../reusable/CardPrecios';
import ModalImageZoom from '../reusable/modals/ImageZoom';
import ModalCompatible from '../reusable/modals/Compatible';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import BtnCompatible from '../reusable/BtnCompatible';
import Spinner from "../reusable/Loader";


const CardOferta = function ({ item, index, event, eventFavorito, auth, zoom, compatible }) {
  return (
    <div className="card_product_horizontal card_oferta mb-0" style={{ height: '100%' }}>
      <div className="cphLeftImage">
        <div className="tag">
          <SvgAssets icon="icon-oferta" fill={color.rojoClaro} className="icon-oferta" />
          <SvgAssets icon="icon-tag" />
        </div>
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.pathI)}>
          <img src={item.pathI} />
        </div>
      </div>
      <div className="cphTextCenter" style={{ justifyContent: 'space-between' }}>
        <div className="mb-2">
          <h6 className="paragraph-2 bold azul mb-1">{item.maktx}</h6>
          <span className="paragraph-3 light d-block">SKU: {item.matnr}</span>
        </div>
        <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
        <div className="options mt-2">
          {/* <BtnCompatible IdInput={item.indice} texto={item.mensajeCompatible} backgroundColor={color.azulClaro} color={'#fff'} /> */}
          <button className='btn-icon'
            type="button"
            onClick={() => compatible(item.mensajeCompatible)}
          >
            <SvgAssets icon="icon-compatible" fill={color.azulClaro} />
          </button>
          <button className="btn-icon" onClick={() => eventFavorito({
            codigo: item.matnr, descripcion: item.maktx,
            moneda: item.waers, pantalla: data.Pantalla.Dashboard.Ofertas
          }, item.favorito, item.indice)}>
            <SvgAssets icon="icon-star" fill={item.favorito ? color.amarillo : color.celeste} />
          </button>
          <div className="desktop">
            <button className="btn-icon desktop" onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
              codigo: item.matnr,
              descripcion: item.maktx,
              precioOferta: item.pOfe,
              precioPublico: item.pPub,
              precioFinal: item.pFin,
              waersS: item.waersS,
              unidadMedida: item.meins,
              precioPVD: item.precioPVD,
              precioPVP: item.precioPVP,
              precioPublico: item.precioPublico,
              moneda: item.waers,
              cantidadOriginal: 1, //item.cantidad,
              cantidad: 1,
              pathI: item.pathI,
              precios: item.precios,
              pantalla: data.Pantalla.Dashboard.Ofertas,
              escalas: data.escalas
            })}>
              <SvgAssets icon="icon-add-cart" />
            </button>
          </div>
        </div>
      </div>
      <div className="cphCounterInput mobile" style={{ backgroundColor: 'rgba(154, 200, 255, 0.3)' }}>
        <button className="btn-icon" onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
          codigo: item.matnr,
          descripcion: item.maktx,
          precioOferta: item.pOfe,
          precioPublico: item.pPub,
          precioFinal: item.pFin,
          waersS: item.waersS,
          unidadMedida: item.meins,
          precioPVD: item.precioPVD,
          precioPVP: item.precioPVP,
          precioPublico: item.precioPublico,
          moneda: item.waers,
          cantidadOriginal: 1, //item.cantidad,
          cantidad: 1,
          pathI: item.pathI,
          precios: item.precios,
          pantalla: data.Pantalla.Dashboard.Ofertas,
          escalas: data.escalas
        })}>
          <SvgAssets icon="icon-add-cart" />
        </button>
      </div>
    </div>
  )
}

export class Dashboard extends Component {
  static displayName = Dashboard.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.getTime = null;
    this.state = {
      activeSlide: 0,
      pillActive: 0,
      loading: true,
      dashboards: [],
      alertas: [],
      dataTab: { montoPagado: 0, fechaVencimientoMeta: new Date() },
      fechaActual: new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }),
      cronometroMeta: { days: 0, hours: 0, minutes: 0 },
      cronometroPedido: { days: 0, hours: 0, minutes: 0 },
      LABELSMETA: [],
      dealer: {},
      linea: {},
      asociado: {},
      addToCart: false,
      dataToCard: {},
      ofertaMes: {
        ofertaMes: []
      },
      pedidoMes: null,
      height: window.innerHeight,
      width: window.innerWidth,
      modalCompatible: false,
      mensajeCompatible: '',
    };
  }

  goToTabHistorial = (codigo) => {
    console.log('tab', codigo)
    this.props.history.push({
      pathname: "/historial-pedidos",
      state: {
        barCodEstado: codigo
      }
    });
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }
  toggleModalCompatible = (texto) => {
    this.setState(prevState => ({
      modalCompatible: !prevState.modalCompatible,
      mensajeCompatible: texto
    }));
  }

  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      // this.props.history.push('/carrito');
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }

  startMetas(data) {
    let label = [];
    var name = 0;
    for (var i = 0; i < data.montoPagado; i++) {
      name++;
      label.push({
        activeBarColor: color.verdeClaro,
        name: `Too Slow ${name}`,
        labelColor: color.verdeClaro,
      });
    }
    for (var i = 0; i < data.montoPorPagar; i++) {
      name++;
      label.push({
        activeBarColor: color.naranja,
        name: `Slow ${name}`,
        labelColor: color.naranja
      });
    }
    for (var i = 0; i < data.saldo; i++) {
      name++;
      label.push({
        activeBarColor: color.rojoClaro,
        name: `Too ${name}`,
        labelColor: color.rojoClaro,
      });
    }
    this.setState({ LABELSMETA: label })
  }
  timeUnitsBetween(endDate) {
    var d = new Date();
    var fechaPerustring = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
      ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
    var fechaGMT = this.formatTimeByOffset(fechaPerustring, 0);

    let startDate = fechaGMT

    let delta = Math.abs(endDate - startDate) / 1000;
    const isNegative = startDate > endDate ? -1 : 1;
    return [
      ['days', 24 * 60 * 60],
      ['hours', 60 * 60],
      ['minutes', 60],
      ['seconds', 1]
    ].reduce((acc, [key, value]) => (acc[key] = Math.floor(delta / value) * isNegative, delta -= acc[key] * isNegative * value, acc), {});
  }
  startClock(flagMeta, flagPedido) {
    this.getTime = setInterval(() => {
      let time = null;
      let timePedido = null
      if (flagMeta) {
        time = this.timeUnitsBetween(new Date(this.state.dataTab.fechaVencimientoMeta));
        this.setState({ cronometroMeta: time })
      }

      if (flagPedido) {
        timePedido = this.timeUnitsBetween(new Date(this.state.pedidoMes.fechaVencimientoPedido));
        this.setState({ cronometroPedido: timePedido })
      }

    }, 480000)
  }
  formatTimeByOffset = (dateString, offset) => {
    // Params:
    // dateString: on the form yyyy-mm-dd hh:mm:ss
    // offset: the amount of hours to add.
    if (!dateString) return ''
    if (dateString.length === 0) return ''
    const year = dateString.slice(0, 4)
    const month = dateString.slice(5, 7)
    const day = dateString.slice(8, 10)
    const hour = dateString.slice(11, 13)
    const minute = dateString.slice(14, 16)
    const second = dateString.slice(17, 19)
    const dateObject = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`)
    const currentHours = dateObject.getHours()
    dateObject.setHours(currentHours + offset)
    return dateObject

  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      validateTokenExpired();
      const auth = this.context;
      this.load(auth.carritoProdctos, auth.setcarritoProdctos, auth.setdealerAlertas, auth.setuserApellidoNombre, auth.setuserCorreo);
    } else
      window.location.href = "/";
  }

  load = (carritoProdctos, setcarritoProdctos, setdealerAlertas, setuserApellidoNombre, setuserCorreo) => {
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: result.dealer, linea: result.linea, asociado: result.asociado }, () => {
      setuserApellidoNombre(result.dealer.apellnombres);
      setuserCorreo(result.dealer.correoElectronico);
      this.postGetData(carritoProdctos, setcarritoProdctos, setdealerAlertas, result.dealer, result.linea, result.asociado);
    })
  }

  next = () => {
    this.slider.slickNext();
  }
  previous = () => {
    this.slider.slickPrev();
  }

  render() {
    const { pedidoMes, ofertaMes, activeSlide, loading, dashboards, alertas, dataTab, pillActive, cronometroMeta, cronometroPedido, LABELSMETA } = this.state;
    console.log('dashboards', dashboards);
    console.log('pedidoMes reder===>', pedidoMes);

    console.log('dataTab reder===>', dataTab);

    const auth = this.context;

    const { width, height } = this.state;
    var carousel_mobile = {
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    var carousel_desktop = {
      dots: false,
      infinite: true,
      arrows: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1
    };

    return (
      <div style={{ flex: 1 }}>
        <Spinner visible={loading} />
        <div className="desktop tab-pills-container">
          <div className="tab-pills">
            {dashboards.map((data, index) => {
              return (
                <button key={index} className={`pill${(pillActive == index ? ' active' : '')}`} disabled={dashboards.length == 1} onClick={() => this.switchPill(index)}>{data.tituloPrincipal}</button>
              )
            })}
          </div>
          <SvgAssets className="curve-bottom" icon="curve-top" fill="#fff" />
        </div>

        <Container className="py-5">
          {/* {(dataTab != null) ? */}
          <div className="row-dashboard">
            <div className="col-card">
              <div className="card">
                <div className="tab-pills mobile">
                  {dashboards.map((data, index) => {
                    return (
                      <button key={index} className={`pill${(pillActive == index ? ' active' : '')}`} onClick={() => this.switchPill(index)}>{data.tituloPrincipal}</button>
                    )
                  })}
                </div>
                {(dashboards.length > 0) ?
                  <div className="meta_box">
                    <p className="paragraph-2 bold">{dataTab.tituloMeta}</p>
                    <span className="title-2"><SvgAssets icon="icon-trofeo" />{dataTab.montoMetStr}</span>
                  </div>
                  : null}
                {(LABELSMETA.length > 0) ?
                  <Row>
                    <Col lg="6">
                      <div className="speedometer">
                        <div className="chart">
                          <GaugeChart id="gauge-chart3"
                            // arcsLength={[0.3, 0.5, 0.2]}
                            arcsLength={[
                              LABELSMETA.filter(x => x.labelColor == color.verdeClaro).length,
                              LABELSMETA.filter(x => x.labelColor == color.naranja).length,
                              LABELSMETA.filter(x => x.labelColor == color.rojoClaro).length,
                            ]}
                            colors={[color.verdeClaro, color.naranja, color.rojoClaro]}
                            // colors={LABELSMETA.map(x => x.labelColor)}
                            // percent={0.37}
                            //percent={dataTab.montoPagado / 100}
                            arcPadding={0.02}
                            arcWidth={0.3}
                            hideText={false}
                            textColor={color.verdeClaro}
                          />
                          {/* <span className="value_chart" style={{ left: '14%' }}>{dataTab.montoPagado}%</span> */}
                          <span className="percent_chart">{dataTab.montoPagado}%</span>
                          <span className="value_chart" style={{ left: '14%' }}>{dataTab.montoPagStr}</span>
                          <span className="value_chart" style={{ right: '6%' }}>{dataTab.montoMetStr}</span>
                        </div>
                        <div className="legend">
                          <div className="item">
                            <div className="dot" style={{ backgroundColor: '#2DB997' }} />
                            <span style={{ color: '#2DB997' }}>Pagados</span>
                            <span className="costo" style={{ color: '#2DB997' }}>{dataTab.montoPagStr}</span>
                          </div>
                          <div className="item">
                            <div className="dot" style={{ backgroundColor: '#FF9446' }} />
                            <span style={{ color: '#FF9446' }}>Pendiente de pago</span>
                            <span className="costo" style={{ color: '#FF9446' }}>{dataTab.montoPorStr}</span>
                          </div>
                          <div className="item">
                            <div className="dot" style={{ backgroundColor: '#F23361' }} />
                            <span style={{ color: '#F23361' }}>Faltante</span>
                            <span className="costo" style={{ color: '#F23361' }}>{dataTab.saldoCumStr}</span>
                          </div>
                        </div>
                      </div>
                      <hr className="mobile" />
                    </Col>
                    <Col lg="6" className="cierre_mes">
                      <h4 className="paragraph-3 desktop_parrafo4 bold azul">Cierre de mes en:</h4>
                      <div className="time-box">
                        <div className="box">
                          <strong>{cronometroMeta.days.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                          <span>Días</span>
                        </div>
                        <i>:</i>
                        <div className="box">
                          <strong>{cronometroMeta.hours.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                          <span>Horas</span>
                        </div>
                        <i>:</i>
                        <div className="box">
                          <strong>{cronometroMeta.minutes.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                          <span>Minutos</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  : null}

                <div className="text-center meta_buttons">
                  {/* <Link to="/dashboard" style={{ textDecoration: 'none' }}> */}
                  <button className='btn-block bg_verde' onClick={() => this.props.history.push('/generar-pedido')}><SvgAssets icon="icon-list" fill="#fff" className="mr-1" />Generar pedido</button>
                  {/* </Link> */}
                  {/* <Link to="/dashboard" style={{ textDecoration: 'none' }}> */}
                  <button className='btn-block' onClick={() => this.props.history.push('/pedido-sugerido')}>Pedido sugerido</button>
                  {/* </Link> */}
                </div>
              </div>
            </div>
            {pedidoMes ?
              <div className="col-card" style={{ flex: 1 }}>
                <div className="card">
                  <span className="title-4 text-center">{pedidoMes.tituloPedido}</span>
                  <BarchartPedidos data={(pedidoMes == null ? [] : pedidoMes.dataEstadosPedido)} />
                  <div className="legend_barchart">
                    {pedidoMes.dataEstadosPedido.map((data, index) => {
                      return (<Link to={{ pathname: "/historial-pedidos", state: { estado: data } }} style={{ color: data.svg.fill }} key={index}><span style={{ backgroundColor: data.svg.fill }} />{data.estado}</Link>);
                    })}
                  </div>
                  <hr className="mobile" />
                  <h4 className="paragraph-3 desktop_parrafo4 bold azul">Próximo pedido vence en:</h4>
                  <div className="time-box">
                    {(cronometroPedido.days) ?
                      <div className="box">
                        <strong>{cronometroPedido.days.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                        <span>Días</span>
                      </div>
                      : null}
                    {(cronometroPedido.days) ?
                      <i>:</i>
                      : null}
                    <div className="box">
                      <strong>{cronometroPedido.hours.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                      <span>Horas</span>
                    </div>
                    <i>:</i>
                    <div className="box">
                      <strong>{cronometroPedido.minutes.toLocaleString("es-PE", { minimumIntegerDigits: 1 })}</strong>
                      <span>Minutos</span>
                    </div>
                  </div>
                </div>
              </div> : null}
          </div>
          {/* :
            <div className="row-dashboard">
              <div className="col-card">
                <div className="card">
                  <div className="text-center meta_buttons">
                    <button className='btn-block bg_verde' onClick={() => this.props.history.push('/generar-pedido')}><SvgAssets icon="icon-list" fill="#fff" className="mr-1" />Generar pedido</button>
                    <button className='btn-block' onClick={() => this.props.history.push('/pedido-sugerido')}>Pedido sugerido</button>
                  </div>
                </div>
              </div>
            </div>
          } */}
          {(ofertaMes.ofertaMes.length > 0) ?
            <div>
              {width < data.isSmallDevice ?
                <div>
                  <h4 className="title-4 my-4" style={{ color: '#fff' }}>
                    {ofertaMes.ofertaMes.length > 0 ? ofertaMes.titulo : ''}
                    <TooltipLeyenda
                      color={'#fff'}
                      style={{ position: 'absolute', right: 0, top: -2 }}
                    />
                  </h4>

                  <Slider ref={c => (this.slider = c)} {...carousel_mobile} >
                    {ofertaMes.ofertaMes.map((carousel, index) => {
                      return (<CardOferta item={carousel} index={index} key={index} event={this.postAgregarProductoPedido} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} compatible={this.toggleModalCompatible} />);
                    })}

                  </Slider>

                  <div className="arrows-slider">
                    <button className="btn-icon" onClick={() => this.previous()}><SvgAssets icon="icon-left" fill='#fff' /></button>
                    <button className="btn-icon" onClick={() => this.next()}><SvgAssets icon="icon-right" fill='#fff' /></button>
                  </div>
                </div>
                : null}
            </div>
            : null}
        </Container>
        {width >= data.isSmallDevice ?
          <div>
            {(ofertaMes.ofertaMes.length > 0) ?
              <div className="gradient_blue py-5">
                <Container id="carousel_ofertas">
                  <h4 className="desktop_parrafo1 text-center mb-5" style={{ color: '#fff' }}>
                    <SvgAssets icon="icon-oferta" fill={color.amarillo} className="mr-2" />{ofertaMes.titulo}
                    <TooltipLeyenda
                      color={'#fff'}
                      style={{ position: 'absolute', right: 0, top: -2 }}
                    />
                  </h4>
                  <Slider ref={c => (this.slider = c)} {...carousel_desktop}>
                    {ofertaMes.ofertaMes.map((carousel, index) => {
                      return (<CardOferta item={carousel} index={index} key={index} event={this.postAgregarProductoPedido} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} />);
                    })}
                  </Slider>
                </Container>
              </div> : null}
          </div> : null
        }
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom dadComponent={this} />
        <ModalCompatible dadComponent={this} texto={this.state.mensajeCompatible} />
      </div>
    );
  }


  postAgregarProductoFavorito = (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    console.log("producto=========>", producto);
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _data = this.state.ofertaMes
          _data.ofertaMes[index].favorito = !AplicaFavorito;
          this.setState({
            ofertaMes: _data
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Oferta Favorito", error.message ?? null);
        });
      });
  }

  postAgregarProductoPedido = (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })
    AgregarProductoPedido(this.state.dealer, producto, this.state.linea, this.state.asociado)
      .then(result => {
        if (result.mo.type == "success") {
          let prod = carritoProdctos;
          // setcarritoProdctos(prod + 1);
          setcarritoProdctos(result.dto.carritoProdctos);
          this.setState({ loading: false, addToCart: true, dataToCard: producto })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }

  switchPill = (index) => {
    let _dashboards = this.state.dashboards;
    this.setState({ pillActive: index, dataTab: _dashboards[index] });
    // if (this.state.pillActive == 0) {
    //   this.setState({ pillActive: 1, dataTab: _dashboards[1] })
    // } else {
    //   this.setState({ pillActive: 0, dataTab: _dashboards[0] })
    // }
    this.startMetas(_dashboards[index]);
    this.startClock(true, false);
  }
  setActiveSlide = (index) => {
    this.setState({ activeSlide: index })
  }

  postGetData = (carritoProdctos, setcarritoProdctos, setdealerAlertas, dealer, linea, asociado) => {
    getData(dealer, linea, asociado)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          setdealerAlertas(result.dto.alertas);

          let time = (result.dto.dashboards.length == 0) ? null : this.timeUnitsBetween(new Date(result.dto.dashboards[0].fechaVencimientoMeta));
          let timePedido = this.timeUnitsBetween(new Date(result.dto.chartEstadosPedido.fechaVencimientoPedido));
          // console.log("timePedido", timePedido);
          // if (result.dto.mensajeDashboards != "" || result.dto.mensajeDashboardsEstadoPedido != "") {

          //   this.setState({
          //     loading: false,
          //     dataTab: result.dto.dashboards[0],
          //     dashboards: result.dto.dashboards,
          //     ofertaMes: result.dto.ofertaMes,
          //     cronometroMeta: time,
          //     cronometroPedido: timePedido,
          //     alertas: result.dto.alertas
          //   }, async () => {
          //     await notificacion("Dashboard", `${result.dto.mensajeDashboards}\n${result.dto.mensajeDashboardsEstadoPedido}`);
          //   });
          //   this.startClock()
          // } else {

          if (result.dto.dashboards.length > 0)
            this.startMetas(result.dto.dashboards[0]);

          console.log("pedidoMes=====>", result.dto.chartEstadosPedido);
          this.setState({
            loading: false,
            dataTab: result.dto.dashboards[0],
            dashboards: result.dto.dashboards,
            ofertaMes: result.dto.ofertaMes,
            pedidoMes: result.dto.chartEstadosPedido,
            cronometroMeta: time,
            cronometroPedido: timePedido,
            alertas: result.dto.alertas
          })
          // let time =   this.timeUnitsBetween(new Date(this.state.dataTab.fechaVencimientoMeta));
          // let timePedido =   this.timeUnitsBetween(new Date(this.state.pedidoMes.fechaVencimientoPedido));

          this.startClock(result.dto.dashboards.length > 0, result.dto.chartEstadosPedido.flagVisible)

          // }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Dashboard", error.message ?? null);
        });
      });

  }

  componentWillUnmount() {
    clearInterval(this.getTime)
  }
}
